import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c31389dc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c31389dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31389dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c31389dc')) {
      api.createRecord('c31389dc', component.options)
    } else {
      api.reload('c31389dc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c31389dc&scoped=true&", function () {
      api.rerender('c31389dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homeCard/buyer/entTrade/goodList/index.vue"
export default component.exports